<template>
  <div>
    <h5>Importação automatizada do CadÚnico</h5>
    <p>Ative para utilizar os leiautes do Excel, comparar versões e importar os campos conforme o mapa de cada versão.</p>
    <p>Status: <strong>{{ ativo ? 'Ativado' : 'Desativado' }}</strong></p>
    <button type="button" class="btn" :class="ativo ? 'btn-danger' : 'btn-success'"
      :disabled="carregando || salvando || erroCarga" @click="alternar">
      {{ carregando || salvando ? 'Aguarde...' : (ativo ? 'Desativar' : 'Ativar') }}
    </button>
    <button v-if="erroCarga" type="button" class="btn btn-link" @click="carregar">Tentar novamente</button>
    <router-link v-if="ativo" to="/dashboard/importacao/leiautes" class="btn btn-outline-primary ml-2">Gerenciar leiautes</router-link>
    <p class="text-muted mt-3 mb-0">Desativado por padrão. Novos envios utilizam a importação antiga enquanto esta opção estiver desativada. Importações já enviadas e reprocessamentos mantêm o modo do envio original.</p>
  </div>
</template>

<script>
export default {
  data() {
    return { ativo: false, carregando: true, salvando: false, erroCarga: false };
  },
  mounted() { this.carregar(); },
  methods: {
    async carregar() {
      this.carregando = true;
      this.erroCarga = false;
      try {
        const response = await axios.get('api/dashboard/admin/importacao/configuracao');
        this.ativo = response.data.data.ativo;
      } catch (error) {
        this.erroCarga = true;
        this.$snack.danger({ button: false, text: 'Não foi possível consultar o parâmetro de importação.' });
      } finally { this.carregando = false; }
    },
    async alternar() {
      this.salvando = true;
      try {
        const response = await axios.put('api/dashboard/admin/importacao/configuracao', { ativo: !this.ativo });
        this.ativo = response.data.data.ativo;
        this.$snack.success({ button: false, text: 'Parâmetro de importação salvo.' });
      } catch (error) {
        const data = error.response && error.response.data;
        this.$snack.danger({ button: false, text: (data && data.message) || 'Não foi possível salvar o parâmetro.' });
      } finally { this.salvando = false; }
    },
  },
};
</script>
